module.exports = __webpack_public_path__ + "media/images/top/qa/qa_show_banner04-892411122ce02dd3da8fccfb24e5ae85.jpg";